import { render, staticRenderFns } from "./CustomDomainEdit.vue?vue&type=template&id=136d14ba&"
import script from "./CustomDomainEdit.vue?vue&type=script&lang=js&"
export * from "./CustomDomainEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports